// extracted by mini-css-extract-plugin
export var alt = "ParagraphBody-module--alt--4410a";
export var container = "ParagraphBody-module--container--e1da1";
export var description = "ParagraphBody-module--description--04c93";
export var desktopOnly = "ParagraphBody-module--desktopOnly--99d52";
export var main = "ParagraphBody-module--main--7d5b9";
export var mobileOnly = "ParagraphBody-module--mobileOnly--5249e";
export var readMore = "ParagraphBody-module--readMore--b5291";
export var textLeft = "ParagraphBody-module--textLeft--68a7f";
export var visuallyHidden = "ParagraphBody-module--visuallyHidden--1936e";